import { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import apiFetch from '../../../utils/apiFetch';

// DM-set art scales for custom player tokens, keyed by image URL and Cloudinary public ID.
export default function useCustomTokenScales(campaignId) {
  const [scales, setScales] = useState({});
  useEffect(() => {
    setScales({});
    if (!campaignId) return undefined;
    let alive = true, latest = 0;
    const refresh = async () => {
      const request = ++latest;
      try {
        const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/custom-player-tokens`);
        if (!response.ok) return;
        const data = await response.json();
        if (!alive || request !== latest) return;
        const next = {};
        (data.assets || []).forEach(({ secureUrl, publicId, displayScale }) => {
          if (secureUrl) next[secureUrl] = displayScale;
          if (publicId) next[publicId] = displayScale;
        });
        setScales(next);
      } catch (_) { /* Tokens fall back to their last known scale. */ }
    };
    const socket = io(process.env.REACT_APP_API_URL || undefined, { withCredentials: true });
    const join = () => socket.emit('campaign:join', campaignId, result => { if (result?.status === 'joined') refresh(); });
    socket.on('connect', join); socket.on('campaign:custom-tokens:update', refresh); join(); refresh();
    return () => {
      alive = false;
      socket.off('connect', join); socket.off('campaign:custom-tokens:update', refresh);
      socket.emit('campaign:leave', campaignId); socket.disconnect();
    };
  }, [campaignId]);
  return scales;
}
